/**
 * Cross-licensed locale groups.
 *
 * When all agents associated with a buyer are in the same cross-licensed locale,
 * the property state can match any of the agents' states. Otherwise, the state
 * must match the primary agent's state.
 *
 * @see https://residenetwork.atlassian.net/wiki/spaces/ENG/pages/4135911425/Multi-State+Buyer+Agreements
 */
const CROSS_LICENSED_LOCALE_GROUPS: string[][] = [['DC', 'MD']];

export function getCrossLicensedLocale(state: string) {
  return CROSS_LICENSED_LOCALE_GROUPS.find((group) => group.includes(state));
}
